import { render, staticRenderFns } from "./CartItemRemove.vue?vue&type=template&id=92f07b5c&scoped=true&"
import script from "./CartItemRemove.vue?vue&type=script&lang=js&"
export * from "./CartItemRemove.vue?vue&type=script&lang=js&"
import style0 from "./CartItemRemove.vue?vue&type=style&index=0&id=92f07b5c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f07b5c",
  null
  
)

export default component.exports